<template>
  <div>
    <h1>Page Not Found</h1>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam at ultrices purus. Mauris condimentum maximus nisl, in euismod dui posuere ac. Aenean pellentesque egestas elementum. Nunc congue turpis eget nisl fermentum, sit amet suscipit turpis gravida. Cras scelerisque mi nisi, at suscipit risus lacinia vel. Aliquam ullamcorper venenatis accumsan. Morbi eget nisl quis tellus eleifend dapibus. Phasellus vitae interdum lectus, nec finibus enim. Interdum et malesuada fames ac ante ipsum primis in faucibus. Maecenas ullamcorper a nibh et ornare.</p>
  </div>
</template>

<script>
export default {
  //
}
</script>

<style lang="scss" scoped>
  div:first-of-type {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10vw;
  }
</style>
